<template>
  <footer class="footer-shell min-w-1400">
    <div class="footer-main max-w-1400">
      <div class="footer-top">
        <div
          v-for="item in contactItems"
          :key="item.title"
          class="contact-item"
        >
          <span class="contact-item__title">{{ item.title }}</span>

          <a
            v-if="item.pill"
            :href="item.href"
            class="contact-pill"
            :target="item.target || null"
            :rel="item.target === '_blank' ? 'noopener noreferrer' : null"
          >
            <span class="contact-pill__icon" aria-hidden="true">{{
              item.icon
            }}</span>
            <span>{{ item.value }}</span>
          </a>

          <a
            v-else-if="item.href"
            :href="item.href"
            class="contact-link"
            :target="item.target || null"
            :rel="item.target === '_blank' ? 'noopener noreferrer' : null"
          >
            <span class="contact-link__icon" aria-hidden="true">{{
              item.icon
            }}</span>
            <span>{{ item.value }}</span>
          </a>

          <div v-else class="contact-link contact-link--static">
            <span class="contact-link__icon" aria-hidden="true">{{
              item.icon
            }}</span>
            <span>{{ item.value }}</span>
          </div>
        </div>
      </div>

      <div class="footer-content">
        <div class="footer-brand">
          <div class="brand-head">
            <img
          :src="logoImg"
          :alt="logo"
          class="logoImg"
        />
          </div>

          <h2 class="brand-company">{{ companyName }}</h2>
        </div>
        <div class="footer-linksAll">
          <div
            v-for="section in footerSections"
            :key="section.title"
            class="footer-links"
          >
            <h3 class="footer-links__title">{{ section.title }}</h3>
            <ul class="footer-links__list">
              <li
                v-for="item in section.items"
                :key="`${section.title}-${item.label}`"
                class="footer-links__item"
              >
                <router-link
                  v-if="item.to"
                  :to="item.to"
                  class="footer-links__anchor"
                >
                  {{ item.label }}
                </router-link>

                <a
                  v-else
                  :href="item.href"
                  class="footer-links__anchor"
                  :target="item.target || null"
                  :rel="item.target === '_blank' ? 'noopener noreferrer' : null"
                >
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-app">
          <h3 class="footer-links__title">Tải ứng dụng Lavi Finance</h3>
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <div class="app-buttons">
            <a
              href="https://apps.apple.com/vn/app/lavi-finance/id6741784212"
              target="_blank"
              class="app-store-btn"
            >
              <svg class="app-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div class="app-text">
                <span class="app-small">Download on the</span>
                <span class="app-large">App Store</span>
              </div>
            </a>
          </div>
          <img style="border-radius: 20px; width: 200px; margin-top: 20px;" :src="q1" alt="">
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>
          © {{ companyName }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import "./index.css";

const companyName = "CÔNG TY TNHH MỘT THÀNH VIÊN QUẢN LÝ NỢ VÀ KHAI THÁC TÀI SẢN NGÂN HÀNG THƯƠNG MẠI CỔ PHẦN QUỐC TẾ VIỆT NAM";
const email = "service@lavifinance.com";
const phone = "916230656";
const phoneLink = "916230656";
const address = "Ton That Tung Street, Coninco Tower Building, Floor 12, Kim Lien Ward Vietnam";
const privacyLink1 = "/privacy";
const privacyLink2 = "/protocol";

import logoImg from "@/page/lavifinancecompany/components/img/logo-white.png";
import q1 from "@/page/lavifinancecompany/components/img/q-1.png";
// const appLink = "https://play.google.com/store/apps/details?id=com.miducoinvestment.loan.vn";

export default {
  data() {
    return {
      q1,
      logoImg,
      companyName,
      email,
      phone,
      phoneLink,
      address,
      contactItems: [
        {
          title: "Hotline",
          value: phone,
          href: `tel:${phoneLink}`,
          icon: "☎",
          pill: true,
        },
        {
          title: "Email",
          value: email,
          href: `mailto:${email}`,
          icon: "✉",
        },
        {
          title: "Địa chỉ",
          value: address,
          icon: "⌖",
        },
      ],
      footerSections: [
        {
          title: "Sản phẩm",
           items: [
            { label: "Sản phẩm", to: "/" }
          ],
        },
        {
          title: "Tin tức & Khuyến mãi",
          items: [
            { label: "Khuyến mãi", to: "/about" },
            { label: "Kiến thức tài chính", to: "/about" }
          ],
        },
        {
          title: "Văn hóa Lavi",
           items: [
            { label: "Văn hóa Lavi", to: "/question" }
          ],
        },
        {
          title: "Trung tâm pháp lý",
          items: [
            { label: "Chính sách bảo mật", to: `${privacyLink1}` },
            { label: "Điều khoản dịch vụ", to: `${privacyLink2}` }
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.footer-shell {
  display: flex;
  justify-content: center;
  width: 100%;
  color: #ffffff;
  background: #001c80;
}

.footer-main {
  width: 100%;
  padding: 36px 48px 28px;
  background: #001c80;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 42px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.contact-item {
  flex: 1 1 280px;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 52px;
  padding: 0 24px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
}

.contact-item:first-child {
  padding-left: 0;
}

.contact-item:last-child {
  padding-right: 0;
  border-right: none;
}

.contact-item__title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.contact-pill,
.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.contact-pill:hover,
.contact-link:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.contact-pill {
  padding: 10px 18px;
  border-radius: 999px;
  background: #ffffff;
  color: #001c80;
  font-weight: 700;
}

.contact-pill__icon,
.contact-link__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
  line-height: 1;
}

.contact-pill__icon {
  background: rgba(0, 28, 128, 0.08);
  color: #ff965e;
}

.contact-link__icon {
  background: rgba(255, 255, 255, 0.14);
}

.contact-link--static {
  cursor: default;
}

.footer-content {
  display: grid;
  grid-template-columns: minmax(320px, 1.5fr) repeat(3, minmax(180px, 1fr)) minmax(
      230px,
      1fr
    );
  gap: 36px;
}

.footer-brand {
  max-width: 360px;
}

.brand-head {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 26px;
}

.brand-mark {
  display: flex;
  flex-direction: column;
}

.brand-mark__line {
  font-size: 34px;
  font-weight: 900;
  line-height: 0.92;
  letter-spacing: 0.08em;
}

.brand-tagline {
  color: #ff965e;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
}

.brand-company {
  margin: 0 0 16px;
  font-size: 21px;
  font-weight: 400;
  line-height: 1.45;
  text-transform: uppercase;
  color: white;
}

.brand-address {
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 17px;
  line-height: 1.7;
}

.brand-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 18px;
}

.brand-detail {
  color: rgba(255, 255, 255, 0.88);
  text-decoration: none;
  font-size: 16px;
  line-height: 1.5;
}

.brand-detail:hover {
  color: #ffffff;
}

.social-list {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 28px;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 46px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}

.social-link--wide {
  font-size: 12px;
  letter-spacing: 0.04em;
}
.footer-linksAll{
  grid-column: span 3;
  display: flex;
}

.footer-links{
  flex: 1 1 280px;
}

.footer-links__title {
  margin: 0 0 22px;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
  color: white  ;
}

.footer-links__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-links__item + .footer-links__item {
  margin-top: 18px;
}

.footer-links__anchor {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.5;
}

.footer-links__anchor:hover {
  color: #ff965e;
}

.store-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.store-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  min-width: 210px;
  padding: 12px 16px;
  color: #ffffff;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
}

.store-badge__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
}

.store-badge__content {
  display: flex;
  flex-direction: column;
}

.store-badge__content small {
  color: rgba(255, 255, 255, 0.68);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.store-badge__content strong {
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}

.app-extras {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 20px;
}

.qr-card {
  position: relative;
  width: 138px;
  height: 138px;
  padding: 14px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: inset 0 0 0 1px rgba(0, 28, 128, 0.08);
}

.qr-card__grid {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  background-image:
    repeating-linear-gradient(
      0deg,
      rgba(0, 28, 128, 0.18) 0 5px,
      transparent 5px 10px
    ),
    repeating-linear-gradient(
      90deg,
      rgba(0, 28, 128, 0.18) 0 5px,
      transparent 5px 10px
    );
}

.qr-card__finder {
  position: absolute;
  width: 30px;
  height: 30px;
  background: #ffffff;
  border: 6px solid #001c80;
  border-radius: 6px;
}

.qr-card__finder::after {
  position: absolute;
  inset: 4px;
  content: "";
  background: #001c80;
  border-radius: 2px;
}

.qr-card__finder--top-left {
  top: 10px;
  left: 10px;
}

.qr-card__finder--top-right {
  top: 10px;
  right: 10px;
}

.qr-card__finder--bottom-left {
  bottom: 10px;
  left: 10px;
}

.qr-card__label {
  position: absolute;
  right: 14px;
  bottom: 14px;
  padding: 4px 8px;
  color: #001c80;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.08em;
  background: #ff965e;
  border-radius: 999px;
}

.dmca-badge {
  display: inline-flex;
  width: fit-content;
  overflow: hidden;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}

.dmca-badge__tag,
.dmca-badge__text {
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}

.dmca-badge__tag {
  color: #ffffff;
  background: #4caf50;
}

.dmca-badge__text {
  color: rgba(255, 255, 255, 0.88);
  background: rgba(0, 0, 0, 0.26);
}

.footer-bottom {
  margin-top: 46px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
}

.footer-bottom p {
  margin: 0;
  max-width: 1160px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 15px;
  font-weight: 500;
  line-height: 1.8;
}

@media (max-width: 1500px) {
  .footer-main {
    padding: 32px 28px 24px;
  }

  .footer-content {
    grid-template-columns: minmax(320px, 1.5fr) repeat(3, minmax(180px, 1fr));
  }

  .footer-app {
    
    grid-column: 2 / -1;
  }
}

@media (max-width: 1200px) {
  .footer-top {
    gap: 18px;
  }

  .contact-item {
    padding: 0;
    border-right: none;
  }

  .footer-content {
    grid-template-columns: repeat(2, minmax(260px, 1fr));
  }

  .footer-app {
    grid-column: auto;
  }
}

/* App Store 按钮样式 */
.app-buttons {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.app-store-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background-color: #000000;
  color: #ffffff;
  padding: 10px 16px;
  border-radius: 8px;
  text-decoration: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.app-store-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.app-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.app-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.app-small {
  font-size: 10px;
  opacity: 0.9;
}

.app-large {
  font-size: 16px;
  font-weight: 600;
}

@media (max-width: 860px) {
  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-item {
    width: 100%;
  }

  .footer-content {
    grid-template-columns: 1fr;
  }

  .footer-brand {
    max-width: none;
  }
}
</style>
